import Component from '@glimmer/component';
import { local } from 'embroider-css-modules';

import styles from './loading-bar.module.css';

interface PrismLoadingBarSignature {
  Args:
    | {
        isFixed: true;
        positionTop: number;
      }
    | {
        isFixed?: false;
        positionTop?: number;
      };
  Element: HTMLDivElement;
}

export default class PrismLoadingBar extends Component<PrismLoadingBarSignature> {
  get styleForLoadingBar(): string {
    const { isFixed, positionTop } = this.args;

    return isFixed ? `top: ${positionTop}px;` : '';
  }

  <template>
    <div
      class={{local styles "container" (if @isFixed "is-fixed")}}
      data-test-loading-bar
      style={{this.styleForLoadingBar}}
      ...attributes
    >
      <div class={{styles.loading-bar}}></div>
    </div>
  </template>
}
